module.exports = __webpack_public_path__ + "img/extra-modal.83b898c4.svg";